import { render, staticRenderFns } from "./PppiStats.vue?vue&type=template&id=5ddbc4ef&scoped=true"
import script from "./PppiStats.vue?vue&type=script&lang=js"
export * from "./PppiStats.vue?vue&type=script&lang=js"
import style0 from "./PppiStats.vue?vue&type=style&index=0&id=5ddbc4ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddbc4ef",
  null
  
)

export default component.exports